import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SubscriptionModal.css';

interface SubscriptionModalProps {
  onClose: () => void;
}

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({ onClose }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div 
      className="subscription-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="subscription-modal">
        {/* Close button */}
        <button 
          onClick={onClose}
          className="subscription-modal-close"
          aria-label="Close"
        >
          ×
        </button>

        <div className="text-center">
          {/* Icon */}
          <div className="subscription-modal-icon">
            <i className="fas fa-crown"></i>
          </div>

          {/* Title */}
          <h2 className="text-white mb-3 text-xl sm:text-2xl font-bold">
            Subscription Required
          </h2>

          {/* Description */}
          <p className="text-gray-400 mb-6 text-sm sm:text-base">
            Subscription required to watch movies
          </p>

          {/* Benefits */}
          <div className="subscription-modal-benefits">
            <div className="subscription-benefit-item">
              <i className="fas fa-check-circle text-green-400"></i>
              <span>Watch all movies & series</span>
            </div>
            <div className="subscription-benefit-item">
              <i className="fas fa-check-circle text-green-400"></i>
              <span>HD streaming quality</span>
            </div>
            <div className="subscription-benefit-item">
              <i className="fas fa-check-circle text-green-400"></i>
              <span>Create unlimited watch parties</span>
            </div>
          </div>

          {/* Trial banner */}
          <div className="subscription-modal-trial">
            <p className="font-bold text-base sm:text-lg mb-1">
              🎁 14 Days Free Trial
            </p>
            <p className="text-sm">
              Then €4.99/month - Cancel anytime
            </p>
          </div>

          {/* CTA Button */}
          <Link
            to="/subscribe"
            className="subscription-modal-cta"
          >
            Start Free Trial Now
          </Link>

          {/* Back link */}
          <button
            onClick={onClose}
            className="subscription-modal-back"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
